import React from 'react'
import { useSelector } from 'react-redux';

import { getSettings } from '../util/getSettings';

function ResultsCount() {
    const communities = useSelector((state) => state.communities);
    const labels = getSettings(['century', 'labels'], true);

    return (
        <div className='results-count' aria-live='assertive'>
            {communities.isFetching && <div className='d-flex align-items-center'><span className="spinner-border"></span>{labels.loadingMessageLabel}</div>}

            {!communities.isFetching && communities.timeStamp !== null && (
                <div className='matches'>
                    <span>{communities.response.data.total}</span>{' '}
                    {labels.communitiesMatchYourSearchSuffixLabel}
                </div>
            )}
        </div>
    )
}

export default ResultsCount